<template>
  <div>
     <div >
     
       <section class="m-l-30 m-r-30">
         <b-row>
           <b-col cols="7">
              <h3 class="m-b-0">Print Queue & Quality assurance</h3>
              <a href="" class="showStatBtn" @click.prevent="showHideStats">{{ isStatShown ? 'Hide' : 'Show'}} Stats</a>
              <a href="" class="showStatBtn text-danger m-l-10" @click.prevent="refreshStats" >
                <i class="fa fa-refresh"></i>
              </a>
           </b-col>
           <b-col  cols="5">
                <online-users :currently-on-page="currentlyOnPage" class="float-right m-t-10" />
           </b-col>
           <b-col cols="12" v-if="isStatShown">
             <items-list-status-stats :stats="stats"/>
           </b-col>
         </b-row>
       </section>
       
    

       <div class="m-l-20 m-r-20 m-b-15">
         <!-- <div>
           <search-items-list />
         </div> -->
         <b-row>
            <b-col cols="3">
              <tabs-items-list :inactive="searchFilters ? true : false"/>
            </b-col>
            <b-col cols="9">
               <bulk-actions-on-items-list :selected-items="selectedItems" />
               
            </b-col>
  
            
         </b-row>
       </div>

       <transition name="fade" mode="out-in">
          <search-and-export-print-queue-data v-if="isExportWidgetVisible"/>
       </transition>

      <div class="m-l-30 m-r-30">
        <b-row class="m-t-20 m-b-20">
          <b-col cols="3">
             <b-form-select v-model="ordering" :options="options" @change="changeData"></b-form-select>
          </b-col>
          <b-col cols="6">
            <p class="m-t-10">Total records found for specified conditions : <strong>{{ itemsCount }}</strong></p>
          </b-col>
          <b-col>
            <b-btn :variant="searchFilters ? 'primary' : 'outline-primary'" @click="showUpdateActionWidget = !showUpdateActionWidget" :disabled="!searchFilters">Update Searched Data <span class="text-lg">{{ showUpdateActionWidget ? '-' : '+' }}</span></b-btn>
          </b-col>
        </b-row>
      </div>


      <update-searched-print-queue-data :search-result-count="itemsCount" v-if="showUpdateActionWidget && searchFilters" :search-filters="searchFilters"/>

      
      
        
       <item-list-table-header />

          

           <single-item-in-list v-for="item in items" :key="item.id" :item="item" :addToSelection="addToSelection" />


       
     </div>
     <infinite-loading @infinite="fetchItemList" :identifier="infiniteId" ></infinite-loading>

     <notify-new-items-in-list v-if="isNewDataAdded" :change-data="changeData" :utc="utcDateTime"/>

     <customer-draft-slide-out slide-out-title="Files & Drafts" :draft-sendable="false"/>
     
  </div>
</template>

<script>
const SingleItemInList = () => import(/* webpackChunkName: "single-item-in-list" */ "./single-item-in-list")
const ItemListTableHeader = () => import(/* webpackChunkName: "item-list-table-header" */ "./item-list-table-header")
const NotifyNewItemsInList = () => import(/* webpackChunkName: "notify-new-items-in-list"*/ "./notify-new-items-in-list")

const CustomerDraftSlideOut = () => import(/* webpackChunkName: "orders.customer-draft-slideout" */ '../orders/customer-drafts/customer-draft-slideout')


import ItemListService from '../../services/item-list.service'
import InfiniteLoading from 'vue-infinite-loading';
import Vue from 'vue'
import EventBus from '../../EventBus'

import io from 'socket.io-client';
import { IS_LIVE } from '../../services/constants';
const SOCKET_NAMESPACE = '/item-list-section';
const OnlineUsers = () => import(/* webpackChunkName: "item-list.online-users" */ './online-users');
const TabsItemsList = () => import(/* webpackChunkName: "tabs-item-list" */ './tabs-items-list.vue')
import _ from 'lodash';

const SearchItemsList = () => import(/* webpackChunkName: "search-items-list" */ './search-items-list')
const BulkActionsOnItemsList = () => import(/* webpackChunkName: "bulk-actions-on-items-list" */ "./bulk-actions-on-items-list") 

const ItemsListStatusStats = () => import(/* webpackChunkName: "items-list-status-stats" */ "./items-list-status-stats");


const SearchAndExportPrintQueueData = () => import(/* webpackChunkName: "items-list.export-print-queue-data" */ "./search-and-export-print-queue-data.vue")

const UpdateSearchedPrintQueueData = () => import(/* webpackChunkName: "item-list.update-searched-print-queue-data" */ "./update-searched-print-queue-data.vue")

  export default {
    components: {SingleItemInList, InfiniteLoading, ItemListTableHeader, OnlineUsers, TabsItemsList, NotifyNewItemsInList, SearchItemsList, BulkActionsOnItemsList, ItemsListStatusStats, ItemsListStatusStats, SearchAndExportPrintQueueData, CustomerDraftSlideOut, UpdateSearchedPrintQueueData},
    data(){
      return {
        page: 1,
        items: [],
        itemsPkArray: [],
        socket : null,
        currentlyOnPage: {},
        infiniteId: +new Date(),
        tab: 'initial',
        isNewDataAdded: false,
        searchOptions: {},
        stats: {},
        isStatShown: true,
        searchFilters: null,
        itemsCount: 0,
        ordering: "createdAt, DESC",
        options: [
          { value: "createdAt, DESC", text: 'Creation Date Desc' },
          { value: 'createdAt, ASC', text: 'Creation Date ASC' },
          { value: "updatedAt, DESC", text: 'Updated Date Desc' },
          { value: 'updatedAt, ASC', text: 'Updated Date ASC' },
          { value: "printFileSentDateTime, DESC", text: 'Print File Sent Desc' },
          { value: 'printFileSentDateTime, ASC', text: 'Print File Sent ASC' },
          { value: "printFileCheckedDateTime, DESC", text: 'Print File Checked Desc' },
          { value: 'printFileCheckedDateTime, ASC', text: 'Print File Checked ASC' },
          { value: "printFilePrintedDateTime, DESC", text: 'Print File Printed Desc' },
          { value: 'printFilePrintedDateTime, ASC', text: 'Print File Printed ASC' },
        ],
        showUpdateActionWidget: false
      }
    },
    mounted(){

      this.socket = io(`${IS_LIVE ? '' : 'http://localhost:3000'}${SOCKET_NAMESPACE}`);
      this.socket.emit('login',{userId: this.loggedInUser.username  });

      this.refreshStats()

      EventBus.$on('item-in-list-updated', (data) => {

         console.log("item-in-list-updated", data)

          const indexOfItem = this.items.findIndex((item) => item.id == data.id);
          Vue.set(this.items, indexOfItem, data.theItem);

          this.socket.emit('ITEM_IN_LIST.UPDATED', data);
          
          
      })

    EventBus.$on('items-list.country-set', (data) => {

          const indexOfItem = this.items.findIndex((item) => item.id == data.id);
          Vue.set(this.items, indexOfItem, data);

          this.socket.emit('ITEM_IN_LIST.UPDATED', data);
          
          
      })


      EventBus.$on('items-list.tags-updated', (data) => {

          const indexOfItem = this.items.findIndex((item) => item.id == data.id);
          Vue.set(this.items, indexOfItem, data);

          this.socket.emit('ITEM_IN_LIST.UPDATED', data);
          
      })
      

       EventBus.$on('item-list.removed-item', (itemId) => {
           const filteredItems = this.items.filter(item => item.id != itemId);
           this.items = filteredItems;

           this.socket.emit('ITEM_IN_LIST.DELETED', itemId);


       })


       this.socket.on('ITEM_IN_LIST.UPDATE_OTHERS', (data) => {
           console.log('Item updated');
           const indexOfItem = this.items.findIndex((item) => item.id == data.id);
           console.log(indexOfItem, data.theItem.sizeOrType)
           Vue.set(this.items, indexOfItem, data.theItem);

           
       });

        this.socket.on('ITEM_IN_LIST.DELETE_FOR_OTHERS', (itemId) => {
           const filteredItems = this.items.filter(item => item.id != itemId);
           this.items = filteredItems;

           this.$toasted.show('Someone deleted item from list', {
                  type: "info",
                  action: {
                    text: "Close",
                    class: "toastBtnTxt",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                  duration: 5000,
              });
       });

       this.socket.on('ITEM_IN_LIST.REMOVE_ITEM_FROM_LIST', itemId => {
           const filteredItems = this.items.filter(item => item.id != itemId);
           this.items = filteredItems;
       })

       this.socket.on('users-on-page', users => {
          console.log('Users on page fired')
          this.currentlyOnPage = users;
       })

       this.socket.on('ITEM_IN_LIST.NOTIFY_NEW_DATA', utcDateTime => {
            this.isNewDataAdded = true;
            this.utcDateTime = utcDateTime;
       })

      // Tab changed

      EventBus.$on('items-list.tab-changed', tabname => {
        console.log('Tab changed fired');
        this.tab = tabname;
        this.changeData()
      })

      // PrintFileSent status changed
      EventBus.$on('items-list.print-file-sent-added', (itemId) => {
           console.log('Print File sent added');
           const filteredItems = this.items.filter(item => item.id != itemId);
           this.items = filteredItems;

           this.socket.emit('ITEM_IN_LIST.PRINT_FILE_SENT', itemId);
      })

      EventBus.$on('item-list.searched', (searchOptions) => {
         this.searchOptions = searchOptions;
         this.changeData()
      })

      EventBus.$on('items-list.bulk-actions-done', data => {

          

          this.updateMultipleItems(data, false);

        
          this.socket.emit('items-list.bulk-update', data);

      })

       this.socket.on('items-list.bulk-update', data => {
             this.updateMultipleItems(data, true);
       })

       EventBus.$on('items-list.deselect-all', () => {
          
          this.items.forEach((item, index) => {
             if(item.selected){
               console.log('Deselect event', item.orderNoWithPrefix, item.selected)
               item.selected = false;
               let updatedItem = Object.assign({}, item)
               Vue.set(this.items, index, updatedItem);
             }
          })
       })

       EventBus.$on('print-queue.filters-updated', (filters) => {
            console.log('Filters updated. Search Again', filters)
            this.searchFilters = filters;
            this.changeData()
       })

      EventBus.$on('print-queue.updated-items', () => {
        console.log('print-queue.updated-items')
        this.changeData()
      })


    this.$store.dispatch('itemsList/fetchCountries')
      
    },
    methods: {
       async fetchItemList($state){
          try{
             let data = {
               page: this.page,
               tab: this.tab,
               searchFilters: this.searchFilters,
               ordering: this.ordering
             }
             const itemResult = await ItemListService.fetchItemList(data)

             if(itemResult.data.itemListResult.rows.length){
               this.page +=1;
               itemResult.data.itemListResult.rows = itemResult.data.itemListResult.rows.map(item => {
                 return {
                   ...item,
                   selected: false
                 }
               })
               //this.items.push(...itemResult.data.itemListResult.rows);
               itemResult.data.itemListResult.rows.forEach(itemRow => {
                  if(!this.itemsPkArray.includes(itemRow.id)){
                      this.items.push(itemRow)
                      this.itemsPkArray.push(itemRow.id);
                  }
               })
               this.itemsCount = itemResult.data.itemListResult.count;
               $state.loaded();
             }else{
               $state.complete();
             }
          }catch(errors){
            console.log(errors)
          }
       },
       addToSelection(itemId){
          const indexOfItem = this.items.findIndex((item) => item.id == itemId);
          // make a new copy of the found object and replace it in the items.
          let desiredItem = Object.assign({}, this.items[indexOfItem]);
          
          desiredItem.selected = !desiredItem.selected
          Vue.set(this.items, indexOfItem, desiredItem);
          
       },
       endConnection(){
         this.socket.emit('end')
       },
       generateId(){
         return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
       },
       changeData(isFromChild= false){
          this.page= 1;
          this.items= [];
          this.itemsPkArray = [];
          this.infiniteId = this.generateId();

          if(isFromChild){
             this.isNewDataAdded = false;
          }
       },
       updateMultipleItems(data, isSocket=false){

         data.items.forEach(updateItem => {
             const indexOfItem = this.items.findIndex((item) => item.id == updateItem.id);

              if(isSocket){
                updateItem.selected = false;
              }else{
                updateItem.selected = true;
              }
              
             

             Vue.set(this.items, indexOfItem, updateItem);
          })

          if(data.field == 'printFileSent'){
             let ids = data.items.map(item => item.id)
             const filteredItems = this.items.filter(item => !ids.includes(item.id));
             this.items = filteredItems;
          }

       },
       async fetchStats(){
          try{
             const result = await ItemListService.getStatusStats();
             this.stats = result.data;
          }catch(errors){
            console.log(errors)
          }
       } ,
       showHideStats(){
          this.isStatShown = !this.isStatShown
          this.refreshStats()
       },
       refreshStats(){
          if(this.isStatShown){
             this.fetchStats();
          }
       }
    },
    beforeDestroy(){
      
      EventBus.$off('item-in-list-updated')
      EventBus.$off('item-list.removed-item')
      EventBus.$off('items-list.tab-changed' )
      EventBus.$off('items-list.print-file-sent-added')
      EventBus.$off('item-list.searched')
      EventBus.$off('items-list.bulk-actions-done');
      EventBus.$off('items-list.deselect-all');
      EventBus.$off('print-queue.filters-updated');
      EventBus.$off('items-list.country-set');
      EventBus.$off('print-queue.updated-items')
      this.endConnection()

    },
    computed: {
        loggedInUser(){
          return this.$store.state.auth.user;
        },
        selectedItems(){
           return this.items.filter(item => item.selected).map(item => item.id)
        },
        isExportWidgetVisible(){
           return this.$store.state.itemsList.isExportActive
        }
      }
  }
</script>

<style lang="scss" scoped>
  .showStatBtn{
    font-size: 13px;
  }
</style>